import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as siteAccountAction from 'yoda-site-components/lib/actions/AccountAction';
import * as LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import * as addToCartActions from 'yoda-site-components/lib/actions/AddToCartAction';
import * as MiniPDPActions from 'yoda-site-components/lib/actions/MiniPDPAction';
import * as actions from '../../../actions/MyListAction';
import * as savedListActions from '../../../actions/SavedListActions';
import selectListingRedesign from '../../../selectors/ListingRedesignSelector';
import TrendingList from './TrendingList';

function mapStateToProps(state) {
    return {
        deviceType: state.context.deviceType,
        myListsDetails: state.MyList,
        featureFlag: state.context.featureFlags,
        messagesTexts: state.context.messagesTexts,
        preferences: state.context.preferences,
        headers: state.context.headers,
        shareList: state.savedList.shareList,
        addToCart: state.addToCartSite,
        draftOrder: state.addToCartInterstitialDetails,
        mountOnServer: true,
        accounts: state.context.accounts,
        authenticationSuccess:
            state.signInSliderDetails && state.signInSliderDetails.authenticationSuccess,
        updatedItem: state.miniPDP && state.miniPDP.updatedItem,
        userState: get(state.accounts, 'userProfile.userState', '0'),
        firstName: get(state.accounts, 'userProfile.firstName', '0'),
        isOOSListingEnabled: selectListingRedesign(state),
    };
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    siteAccountAction: bindActionCreators(siteAccountAction, dispatch),
    savedListActions: bindActionCreators(savedListActions, dispatch),
    LoaderAction: bindActionCreators(LoaderAction.default, dispatch),
    addToCartActions: bindActionCreators(addToCartActions.default, dispatch),
    MiniPDPActions: bindActionCreators(MiniPDPActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrendingList);
